import {
  getErrorMessage,
} from '../../utils';
import {
  REQUEST_BACKSTOPDATE,
  RECEIVE_BACKSTOPDATE,
  SET_BACKSTOPDATE_FAILURE,
  CLEAR_BACKSTOPDATE_ERROR_MESSAGE,
} from '../constants/backstopDate';

const initialState = {
  isFetching: false,
  wasCalled: false,
  errorMessage: '',
  backstopDate: null,
};

const backstopdate = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_BACKSTOPDATE: {
      return { ...state, isFetching: true };
    }
    case RECEIVE_BACKSTOPDATE: {
      const { backstopDate } = action;
      return {
        ...state,
        isFetching: false,
        errorMessage: '',
        wasCalled: true,
        backstopDate,
      };
    }
    case SET_BACKSTOPDATE_FAILURE: {
      const { error } = action;
      const errorMessage = getErrorMessage(error);
      return { ...state, isFetching: false, errorMessage, wasCalled: true };
    }
    case CLEAR_BACKSTOPDATE_ERROR_MESSAGE: {
      return { ...state, errorMessage: '' };
    }
    default:
      return state;
  }
};

export default backstopdate;
